// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__YXbJX","inputWrap":"CustomTip_inputWrap__394J3"};